import React, { useState, type ReactNode } from "react";
import { useAuth } from "../hooks/useAuth";

export interface LogoutButtonProps {
  children?: ReactNode;
  className?: string;
  onLoggedOut?: () => void;
}

export function LogoutButton({ children = "Log out", className, onLoggedOut }: LogoutButtonProps) {
  const auth = useAuth();
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    setLoading(true);
    try {
      await auth.logout();
      onLoggedOut?.();
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={loading}
      className={
        className ??
        "fka-logout-button rounded-md px-3 py-1.5 text-sm text-slate-300 transition hover:bg-slate-800 disabled:opacity-60"
      }
    >
      {loading ? "Signing out…" : children}
    </button>
  );
}
